import { render, staticRenderFns } from "./PoyntIsEuTerritory.vue?vue&type=template&id=f7ed152c&"
import script from "./PoyntIsEuTerritory.vue?vue&type=script&lang=ts&"
export * from "./PoyntIsEuTerritory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports